import { BADGE_LABEL, PLAN_LABEL, PLAN_LIMITS, PLAN_PERKS, SELLER_PLANS, type SellerPlan } from "../../shared/market";
import { useI18n } from "../i18n/I18nProvider";
import { useArs } from "./components";

/** What each plan includes, side by side (Mi tienda › Ajustes and the plans page). */
export function PlanCompare({ current }: { current?: SellerPlan }) {
  const { t } = useI18n();
  const ars = useArs();
  const limit = (n: number | null, money = false) => (n === null ? t("mkt.plan.noLimit") : money ? ars(n) : String(n));
  return (
    <div className="plan-compare-wrap">
      <table className="plan-compare">
        <thead>
          <tr>
            <th />
            {SELLER_PLANS.map((p) => (
              <th key={p} className={p === current ? "is-current" : undefined}>
                {PLAN_LABEL[p]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">{t("mkt.plan.rowListings")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{limit(PLAN_LIMITS[p].listings)}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowPrice")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{limit(PLAN_LIMITS[p].maxPriceArs, true)}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowFeatured")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].featuredPerMonth || "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowDemand")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].demandAlerts ? "✓" : "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowCoupons")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].coupons || "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowCustomers")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].customers ? "✓" : "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowEmails")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].shopEmailsPerMonth || "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowInsights")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].insights ? "✓" : "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowSupport")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].prioritySupport ? "✓" : "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowUsd")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].usdPrices ? "✓" : "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowCustomShop")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].customShop ? "✓" : "—"}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowBadge")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{p === "basic" ? "—" : `${BADGE_LABEL[p].icon} ${PLAN_LABEL[p]}`}</td>
            ))}
          </tr>
          <tr>
            <th scope="row">{t("mkt.plan.rowApi")}</th>
            {SELLER_PLANS.map((p) => (
              <td key={p}>{PLAN_PERKS[p].api ? "✓" : "—"}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
